export default __webpack_public_path__ + "static/media/icon-arrow-left.cac75923.svg";